module.exports = __webpack_public_path__ + "img/simbolo-geon.fe95d69a.svg";